/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
function initBFPrice() {
    document.querySelectorAll('[data-section-type="product"]').forEach((section) => {
      const jsonEl = section.querySelector('[data-product-json]');
      if (!jsonEl) return;

      let product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      // Liquid already resolved the sale against the shopper's market, so take the
      // percent off the badge. Reading product.tags here would re-apply a sale that
      // only runs in one market to every market.
      const saleSticker = section.querySelector('.product-discount-badge-tag.product-sale-tag');
      const pct = saleSticker ? parseInt(saleSticker.getAttribute('data-sale-percent'), 10) : 0;
      if (!pct) return;

      const factor = (100 - pct) / 100;

      const money = (cents) => {
        if (window.themeCurrency && theme.moneyFormat) {
          return window.themeCurrency.formatMoney(cents, theme.moneyFormat);
        }
        return '$' + (cents / 100).toFixed(2);
      };

      const apply = (variant) => {
        if (!variant) return;
        const priceEl = section.querySelector('[data-product-price]');
        const strikeEl = section.querySelector('[data-compare-price]');
        const compareText = section.querySelector('[data-compare-text]');
        if (!priceEl) return;

        priceEl.innerHTML = money(Math.round(variant.price * factor));
        priceEl.classList.add('product__price--sale');

        if (strikeEl) {
          strikeEl.innerHTML = money(variant.price);
          strikeEl.classList.remove('hidden');
        }
        if (compareText) compareText.classList.remove('hidden');
      };

      section.addEventListener('theme:variant:change', (e) => {
        requestAnimationFrame(() => apply(e.detail.variant));
      });

      const idInput = section.querySelector('[name="id"]');
      const id = idInput ? parseInt(idInput.value, 10) : null;
      const current = (product.variants || []).find((v) => v.id === id) || product.variants[0];
      requestAnimationFrame(() => apply(current));
    });
  }

  if (document.readyState !== 'loading') {
    initBFPrice();
  } else {
    document.addEventListener('DOMContentLoaded', initBFPrice);
  }

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
